import {guard} from "./helper";
import Egifts from "../views/egift/Egifts";
import EgiftList from "../views/egift/EgiftList";
import EgiftPayment from "../views/egift/EgiftPayment";
import EgiftConfirm from "../views/egift/EgiftConfirm";
import EgiftThanks from "../views/egift/EgiftThanks";
import MyWallet from "../views/egift/MyWallet";

export default [
    {
        path: '/egifts',
        name: 'E-gifts',
        component: Egifts
    },
    {
        path: '/my-wallet/:cardId',
        name: 'My-wallet',
        beforeEnter: guard,
        component: MyWallet
    },
    {
        path: '/egift-list',
        name: 'EgiftList',
        component: EgiftList
    },
    {
        path: '/egift-payment',
        name: 'EgiftPayment',
        component: EgiftPayment
    },
    {
        path: '/egift-confirm',
        name: 'EgiftConfirm',
        component: EgiftConfirm
    },
    {
        path: '/egift-thanks',
        name: 'EgiftThanks',
        component: EgiftThanks
    },
]
